export interface QText {
  hidden?: boolean
  text: string
}
export type Question = QText[]
export type Quiz = Question[]

const regex = /{(?<guess>[^}]*)}/

export function parseQuiz (text: string):Quiz {
  const blocks = text.replaceAll('\r', '').split('Q\n')
  const questions = []
  for (const block of blocks) {
    let curBlock = block
    const elements = []
    let match = block.match(regex)
    const it = 0
    while (match != null) {
      const idx = match.index ?? 0
      elements.push({
        text: curBlock.substring(0, idx)
      })
      const guess = match.groups?.guess ?? ''
      curBlock = curBlock.substring(idx + guess.length + 2)
      elements.push({
        text: guess,
        hidden: true
      })

      match = curBlock.match(regex)
      if (it > 9000) {
        break
      }
    }
    if (curBlock.length) {
      elements.push({ text: curBlock })
    }
    if (elements.length) {
      questions.push(elements)
    }
  }
  return questions
}
